exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../../node_modules/css-loader/index.js??ref--8-1!../../../../../node_modules/postcss-loader/lib/index.js!shared/css/grid.css"), undefined);

// module
exports.push([module.id, "._1daztjgUB_htOLIcn5AyWX{background:url(\"/static/img/shrug.gif\") no-repeat 50%;background-size:contain;height:300px;margin:0 auto;width:" + require("-!../../../../../node_modules/css-loader/index.js??ref--8-1!../../../../../node_modules/postcss-loader/lib/index.js!shared/css/grid.css").locals["grid5"] + "}", ""]);

// exports
exports.locals = {
	"grid": "\"shared/css/grid.css\"",
	"grid5": "" + require("-!../../../../../node_modules/css-loader/index.js??ref--8-1!../../../../../node_modules/postcss-loader/lib/index.js!shared/css/grid.css").locals["grid5"] + "",
	"noResults": "_1daztjgUB_htOLIcn5AyWX"
};